import { jwtDecode } from 'jwt-decode';

export type AccessToken = {
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid': string;
  unique_name: string;
  groupsid: string;
  given_name: string;
  ServiceName: string;
  USER_EMAIL: string;
  USER_NAME: string;
  PARENT_ORGANIZATION_ID: string;
  ORGANIZATION_BUDGET_ID_NUMBER: string;
  security_claims: string[];
  nbf: number;
  exp: number;
  iat: number;
  iss: string;
  aud: string;
};

export const AdminClaim = 'Claim_Admin';

export function decodeAccessToken(token: string): AccessToken | null {
  try {
    return jwtDecode<AccessToken>(token) as AccessToken;
  } catch {
    return null;
  }
}

export function isAccessTokenExpired(expiration: number): boolean {
  return new Date().getTime() > (expiration - 60) * 1000;
}
